import * as t from "io-ts";
import nullable from "./nullable";
import { isoDateTime } from "./date-time";
export const ruleDimensionT = t.keyof({
    TRUCK: null,
    TRAILER: null,
    DRIVER: null,
    CLIENT: null,
    ALL: null,
});
export const rateTypeT = t.keyof({
    FIXED_MONTHLY: null,
    PER_ORDER: null,
    PER_KM: null,
    PER_DAY: null,
    PER_KG: null,
    PER_STOP: null,
    PER_COLLI: null,
    PER_PRODUCT_UNIT: null,
});
export const costCategoryT = t.strict({
    id: t.string,
    name: t.string,
    createdAt: isoDateTime,
});
export const costCategoriesT = t.array(costCategoryT);
export const costCategoryInputT = t.strict({ name: t.string });
export const costRuleT = t.strict({
    id: t.string,
    categoryId: nullable(t.string),
    name: t.string,
    dimension: ruleDimensionT,
    targetId: nullable(t.string),
    productId: nullable(t.string),
    rateType: rateTypeT,
    amount: t.number,
    startDate: nullable(t.string),
    endDate: nullable(t.string),
});
export const costRulesT = t.array(costRuleT);
export const costRuleInputT = t.strict({
    categoryId: nullable(t.string),
    name: t.string,
    dimension: ruleDimensionT,
    targetId: nullable(t.string),
    productId: nullable(t.string),
    rateType: rateTypeT,
    amount: t.number,
    startDate: nullable(t.string),
    endDate: nullable(t.string),
});
export const manualDimensionT = t.keyof({
    TRUCK: null,
    TRAILER: null,
    DRIVER: null,
    CLIENT: null,
    GENERAL: null,
});
export const manualCostT = t.strict({
    id: t.string,
    categoryId: nullable(t.string),
    cargoId: nullable(t.string),
    description: t.string,
    dimension: nullable(manualDimensionT),
    targetId: nullable(t.string),
    amount: t.number,
    date: t.string,
});
export const manualCostsT = t.array(manualCostT);
export const manualCostInputT = t.strict({
    categoryId: nullable(t.string),
    cargoId: nullable(t.string),
    description: t.string,
    dimension: nullable(manualDimensionT),
    targetId: nullable(t.string),
    amount: t.number,
    date: t.string,
});
//# sourceMappingURL=insight-costs.js.map